/**
 * Default reference cookie configuration
 * This file contains the default reference cookie values used by both
 * the Basic Calculator and Pro Calculator components.
 */

// Default reference cookie values in imperial units (inches/oz)
export const DEFAULT_REFERENCE_IMPERIAL = {
  width: '3.5',        // inches
  length: '3.5',       // inches
  weightNoIcing: '1',  // oz
  weight: '1.5'        // oz
};

// Default reference cookie values in metric units (mm/g)
export const DEFAULT_REFERENCE_METRIC = {
  width: '88.9',       // mm (3.5 inches * 25.4)
  length: '88.9',      // mm (3.5 inches * 25.4)
  weightNoIcing: '28.35', // g (1 oz * 28.35)
  weight: '42.52'      // g (1.5 oz * 28.35)
};

// Conversion constants
export const MM_PER_INCH = 25.4;
export const GRAMS_PER_OZ = 28.3495;

// Base default values (Inches and Grams)
const BASE_DEFAULTS = {
  width: '2.5',         
  length: '3.5',        
  weightNoIcing: '40', 
  weight: '54'          
};

// Function to get default reference — always returns canonical units (inches / grams).
// Display conversion is handled at the component boundary.
export const getDefaultReference = () => {
  return { ...BASE_DEFAULTS };
};
